import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PharmasetFilterCriteria from './PharmasetFilterCriteria'
import PharmasetList from './PharmasetList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PharmasetAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPharmasetDashboardPharmasetList } from '../../store/slice/PharmaSlice';

export default function PharmasetListView({setShowEdit,setPharmasetId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.pharmasetDashboard);   

    const [filteredPharmasetList, setFilteredPharmasetList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { pharmasetDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (pharmasetDashboard.pharmasetList.length>-1){
        setFilteredPharmasetList(pharmasetDashboard.pharmasetList);
        transformToCardFormat(pharmasetDashboard.pharmasetList, setCardList);
      }
    },[pharmasetDashboard.pharmasetList])

    useEffect(()=>{
          transformToCardFormat(filteredPharmasetList, setCardList);
      },[filteredPharmasetList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.formid==='' && filterCriteria.formname==='' ){
            setFilteredPharmasetList(pharmasetDashboard.pharmasetList);
            transformToCardFormat(pharmasetDashboard.pharmasetList, setCardList);

        } else {
            setFilteredPharmasetList(
                pharmasetDashboard.pharmasetList
                    .filter(pharmaset=> pharmaset.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(pharmaset=> pharmaset.formid.toString().toUpperCase().includes(filterCriteria.formid.toString().toUpperCase()))
.filter(pharmaset=> pharmaset.formname.toString().toUpperCase().includes(filterCriteria.formname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(pharmasetDashboard.filteredPharmasetList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PharmasetList
                    setShowEdit={setShowEdit}
                    setPharmasetId = {setPharmasetId}
                    tableList={filteredPharmasetList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}